import { sortByDateDesc } from '../../../../../../../utils/date/sort-by-date';
import {
  Dependent,
  IFittingPreviewData,
  IPurchasesData,
} from '../../../../../../../graphql/lenses/models/get-lenses-preview.models';
import { filterPurchases, filterFittings, filterDependentFittings } from './filter-by-removing-brand';

export const getLatestEvent = (purchases: IPurchasesData[], fittings: IFittingPreviewData[], dependents: Dependent[] ) => {
  const allUserEvents = [
    ...filterFittings(fittings),
    ...filterPurchases(purchases),
    ...filterDependentFittings(dependents),
  ];
  let result: IPurchasesData | IFittingPreviewData | undefined;

  if (allUserEvents.length) {
    const sortedEvents = sortByDateDesc(allUserEvents, 'createdDateTime');

    result = sortedEvents[0];
  }

  return result;
};
